import { Box, Grid, Typography } from '@mui/material';
import Image from 'next/image';
import Link from 'next/link';
import PrimaryButton from '../components/buttons/PrimaryButton';
import { pricingOptions } from './data';

const PricingOptions = () => {
  return (
    <div style={{ paddingBlock: '4rem' }}>
      <div className='page__content'>
        <Typography
          color='#3A3E50'
          fontWeight={600}
          fontSize={{ xs: 26, lg: 44 }}
          textAlign={'center'}
          mb={3}
          lineHeight={1}
          component='h2'
        >
          Get Started With The Right Advantage
        </Typography>

        <Grid container>
          {pricingOptions.map((option, index) => (
            <Grid
              key={option.title}
              xs={12}
              sm={12}
              md={6}
              sx={{
                pr: { xs: 0, md: index % 2 === 0 ? 2 : 0 },
              }}
              pb={2}
            >
              <Box
                sx={{ backgroundColor: '#fff', boxShadow: '0px 0px 40px 0px #0017721A', borderRadius: '20px', p: 3 }}
              >
                <Typography
                  fontSize={{
                    xs: 8,
                    lg: 12,
                  }}
                  fontWeight={700}
                  textTransform={'uppercase'}
                  color='#fff'
                  sx={{
                    backgroundColor: '#0F5D85',
                    display: 'inline-block',
                    borderRadius: '30px',
                    p: 1,
                    letterSpacing: '2px',
                  }}
                >
                  {option.badge}
                </Typography>

                <Typography color='#002E33' fontWeight={600} fontSize={{ xs: 18, lg: 24 }} my={1} component='h3'>
                  {option.title}
                </Typography>

                <Typography color='#1D2935' fontWeight={500} fontSize={{ xs: 12, lg: 16 }} mb={2} lineHeight={1.3}>
                  {option.description}
                </Typography>

                <div>
                  {option.items.map(item => (
                    <Box display={'flex'} alignItems={'center'} gap={1} mb={1} key={item}>
                      <Image src={'/assets/images/icon.png'} alt='Icon' width={'24px'} height={'24px'} />
                      <Typography color='#1D2935' fontWeight={500} fontSize={{ xs: 12, lg: 16 }} lineHeight={1.3}>
                        {item}
                      </Typography>
                    </Box>
                  ))}
                </div>

                <Link href={option.link} passHref>
                  <PrimaryButton sx={{ px: 9, py: 2.25, mt: 1 }}>Register</PrimaryButton>
                </Link>
              </Box>
            </Grid>
          ))}
        </Grid>
      </div>
    </div>
  );
};

export default PricingOptions;
